module.exports = "/_next/static/images/GenerativeAI@2x-3bd8c5521a55c50638e11094cfe17934.png";